/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_UploadedInputs */

const en_image_uploaded = /** @type {(inputs: Image_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image uploaded`)
};

const es_image_uploaded = /** @type {(inputs: Image_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen subida`)
};

/**
* | output |
* | --- |
* | "Image uploaded" |
*
* @param {Image_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const image_uploaded = /** @type {((inputs?: Image_UploadedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_UploadedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_image_uploaded(inputs)
	return es_image_uploaded(inputs)
});